// AI GENERATED
import Skeleton from "react-loading-skeleton";

export default function Loading() {
  // Define a constant for the metadata line height if needed,
  // or rely on default line height for smaller text.
  const metadataHeight = 16;

  return (
    <>
      {/* 1. Image Skeleton (The large top block) */}
      <div style={{ aspectRatio: "1.5 / 1", marginBottom: "15px" }}>
        <Skeleton height="100%" />
      </div>

      {/* 2. Title/Heading Skeleton (Bolder/Wider) */}
      <div style={{ marginBottom: "10px" }}>
        {/* The title "Свиристелей не перечесть" is prominent and relatively short */}
        <Skeleton height={30} width="70%" />
      </div>

      {/* 3. Metadata Skeleton (Likes and Date) */}
      <div style={{ display: "flex", marginBottom: "15px" }}>
        {/* Likes count (e.g., 10) */}
        <Skeleton
          height={metadataHeight}
          width="30px"
          style={{ marginRight: "10px" }}
        />
        {/* Date (e.g., 16 января 2025 г.) */}
        <Skeleton height={metadataHeight} width="100px" />
      </div>

      {/* 4. Description Text Block Skeleton */}
      <div style={{ marginBottom: "10px" }}>
        {/* This represents the main text block, typically 3-4 lines */}
        <Skeleton count={3} />
        {/* A shorter line for the trailing ellipsis or last phrase */}
        <Skeleton width="60%" />
      </div>

      {/* 5. Hashtags/Tags Skeleton */}
      <div style={{ display: "flex", marginBottom: "15px" }}>
        <Skeleton
          height={metadataHeight}
          width="90px"
          style={{ marginRight: "8px" }}
        />
        <Skeleton
          height={metadataHeight}
          width="60px"
          style={{ marginRight: "8px" }}
        />
        <Skeleton height={metadataHeight} width="110px" />
      </div>

      {/* 6. Button Skeleton */}
      <div>
        {/* The "Читать" button */}
        <Skeleton height={35} width="80px" />
      </div>
    </>
  );
}
